import type { User } from 'firebase/auth';

export enum EUserRole {
  ADMIN = 'admin',
  EDITOR = 'editor',
  VIEWER = 'viewer',
  CONSUMER = 'consumer',
}

export type TUserRole =
  EUserRole.ADMIN | EUserRole.EDITOR | EUserRole.VIEWER | EUserRole.CONSUMER;

export interface IAuthPayload {
  uid: User['uid'];
  role: EUserRole;
}
